<mat-icon
  *ngIf="isNewPatient$ | ngrxPush"
  class="new-patient-icon"
  [ngClass]="iconSize"
>
  fiber_new
</mat-icon>
